import {StyleSheet} from "@react-pdf/renderer";

export const purchaseSummaryStyles = StyleSheet.create({
    page: {
        padding: 30,
    },
    titleSection: {
        marginBottom: 36,
    },
    section: {
        marginBottom: 24,
    },
    titleHeading: {
        fontSize: 24,
        fontWeight: 'extrabold',
        marginBottom: 8,
    },
    heading: {
        fontSize: 18,
        fontWeight: 'extrabold',
        marginBottom: 5,
    },
    centered: {
        textAlign: 'center',
    },
    description: {
        fontSize: 12,
        marginBottom: 5,
    },
    text: {
        fontSize: 12,
        marginBottom: 2,
    },
    bullet: {
        fontSize: 12,
        marginBottom: 5,
        marginLeft: 10,
    },
    list: {
        marginLeft: 15,
        marginTop: 5,
    },
    footer: {
        marginTop: 20,
        textAlign: 'center',
        fontSize: 12,
    },
    footerImage: {
        marginTop: 10,
        width: '100%', // Adjust width as needed
        height: 100,   // Adjust height as needed
        objectFit: 'contain',
    }
});